import { appendIf, formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { TableColumn, genFormattedColumn, useRowActionsColumn } from '../../../../components/tables/Table'
import { templatesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useOpenDetailsTemplatesModal } from '../../../../utils/routes/modals/modalsActions'
import { useTemplateActions } from './_actions/templateActions'
import { useTemplates } from '../_load/TemplatesLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'

const TemplateTable = () => {
  const { t } = useTranslation()
  const { data: entity } = useCurrentModal()
  const data = useTemplates()
  const openDetailsModal = useOpenDetailsTemplatesModal()

  const columns = [
    {
      label: `Nome `,
      headerSideContent: (
        <>
          <ListCounter
            client={templatesClient}
            entity="templates"
            filterName="TemplateFilter"
            filters={{ entities: [entity], types: ['docx'] }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      render: (name, record) => (
        <Link onClick={() => openDetailsModal(record)}>
          <TableColumn bold>{name}</TableColumn>
        </Link>
      )
    },
    {
      label: 'Tipo',
      dataIndex: 'type',
      sortIndex: false,
      flex: 2
    },
    ...appendIf(entity === 'service_order', {
      label: 'Questionário',
      dataIndex: ['checklist', 'name'],
      sortIndex: false,
      flex: 4
    }),
    {
      label: 'Criado em',
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      render: genFormattedColumn(formatDate('DD/MM/YYYY HH:mm'))
    },
    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useTemplateActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default TemplateTable
